{
  "menu": {
    "labels": {
      "dossierdownloader": "Dossier downloader",
      "overview": "Overview",
      "procedures": "Procedures"
    }
  }
}
